/** Default frame rate (fps) used when an asset does not specify one. */
export const DEFAULT_FRAME_RATE = 24

/** Milliseconds of inactivity before the player control bar auto-hides. */
export const CONTROL_BAR_AUTO_HIDE_DELAY_MS = 3000

/** Seconds to skip forward or backward when using skip buttons. */
export const PLAYBACK_SKIP_SECONDS = 10

/** Volume range used by the HLS.js player UI (matches Bitmovin's 0–100 scale). */
export const VOLUME_MIN = 0
export const VOLUME_MAX = 100

/** Available playback speed options for the HLS.js player settings panel. */
export const PLAYBACK_SPEEDS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] as const

/** Default (normal) playback speed. */
export const DEFAULT_PLAYBACK_SPEED = 1

/** Label for auto quality selection in the quality selector. */
export const AUTO_QUALITY_LABEL = 'Auto'

/**
 * Seconds before the intro end time at which the skip intro button disappears.
 * Matches the Bitmovin behavior: `playingProgress <= introEndTime - 5`.
 */
export const SKIP_INTRO_HIDE_BEFORE_END_SECONDS = 5

/**
 * Seconds after credits start at which the Up Next overlay appears.
 * Bitmovin uses `credits + 8`.
 */
export const UP_NEXT_CREDITS_OFFSET_SECONDS = 8

/**
 * Minimum seconds before the end of the video that the Up Next overlay must appear.
 * Ensures the overlay shows at least this many seconds before playback ends.
 */
export const UP_NEXT_MIN_END_BUFFER_SECONDS = 15

/**
 * Seconds before the credits showTime at which the credits timeframe begins.
 * Provides a small buffer so the Up Next button appears slightly before the exact timestamp.
 */
export const UP_NEXT_CREDITS_EARLY_BUFFER_SECONDS = 1
